const token = { _id: 'token', name: 'Subscription token', shortName: 'Token', color: '#9976F7', type: 'token' };
const cpuUnlock = { _id: 'cpuUnlock', name: 'Cpu Unlock', shortName: 'Unlock', color: '#47B165', type: 'resource' };
const pixel = { _id: 'pixel', name: 'Pixel', shortName: 'Pixel', color: '#FF7378', type: 'resource' };
const accessKey = { _id: 'accessKey', name: 'Access Key', shortName: 'Key', color: '#CCBC30', type: 'resource' };

const energy = { _id: 'energy', name: 'Energy', color: 'rgba(251, 230, 121, .1)', type: 'resource' };
const power = { _id: 'power', name: 'Power', color: 'rgba(236, 58 ,60, .1)', type: 'resource' };
const metal = { _id: 'metal', name: 'Metal', color: 'rgba(149, 111, 92, .1)', type: 'resource' };
const biomass = { _id: 'biomass', name: 'Biomass', color: 'rgba(132, 176, 18, .1)', type: 'resource' };
const silicon = { _id: 'silicon', name: 'Silicon', color: 'rgba(76, 167, 229, .1)', type: 'resource' };
const mist = { _id: 'mist', name: 'Mist', color: 'rgba(218, 107, 245, .1)', type: 'resource' };
const ops = { _id: 'ops', name: 'Ops', color: 'rgba(236, 58 ,60, .1)', type: 'resource' };

const composite = { _id: 'composite', name: 'Composite', color: '', type: 'resource' };
const crystal = { _id: 'crystal', name: 'Crystal', color: '', type: 'resource' };
const liquid = { _id: 'liquid', name: 'Liquid', color: '', type: 'resource' };
const utrium_bar = { _id: 'utrium_bar', name: 'Utrium bar', color: '', type: 'resource' };
const lemergium_bar = { _id: 'lemergium_bar', name: 'Lemergium bar', color: '', type: 'resource' };
const zynthium_bar = { _id: 'zynthium_bar', name: 'Zynthium bar', color: '', type: 'resource' };
const keanium_bar = { _id: 'keanium_bar', name: 'Keanium bar', color: '', type: 'resource' };
const ghodium_melt = { _id: 'ghodium_melt', name: 'Ghodium melt', color: '', type: 'resource' };
const oxidant = { _id: 'oxidant', name: 'Oxidant', color: '', type: 'resource' };
const reductant = { _id: 'reductant', name: 'Reductant', color: '', type: 'resource' };
const purifier = { _id: 'purifier', name: 'Purifier', color: '', type: 'resource' };
const battery = { _id: 'battery', name: 'Battery', color: '', type: 'factory_production' };

const alloy = { _id: 'alloy', name: 'Alloy', color: 'rgba(149, 111, 92)', type: 'factory_production' };
const tube = { _id: 'tube', name: 'Tube', color: 'rgba(149, 111, 92)', type: 'factory_production' };
const fixtures = { _id: 'fixtures', name: 'Fixtures', color: 'rgba(149, 111, 92)', type: 'factory_production' };
const frame = { _id: 'frame', name: 'Frame', color: 'rgba(149, 111, 92)', type: 'factory_production' };
const hydraulics = { _id: 'hydraulics', name: 'Hydraulics', color: 'rgba(149, 111, 92)', type: 'factory_production' };
const machine = { _id: 'machine', name: 'Machine', color: 'rgba(149, 111, 92)', type: 'factory_production' };

const cell = { _id: 'cell', name: 'Cell', color: 'rgba(132, 176, 18)', type: 'factory_production' };
const phlegm = { _id: 'phlegm', name: 'Phlegm', color: 'rgba(132, 176, 18)', type: 'factory_production' };
const tissue = { _id: 'tissue', name: 'Tissue', color: 'rgba(132, 176, 18)', type: 'factory_production' };
const muscle = { _id: 'muscle', name: 'Muscle', color: 'rgba(132, 176, 18)', type: 'factory_production' };
const organoid = { _id: 'organoid', name: 'Organoid', color: 'rgba(132, 176, 18)', type: 'factory_production' };
const organism = { _id: 'organism', name: 'Organism', color: 'rgba(132, 176, 18)', type: 'factory_production' };

const wire = { _id: 'wire', name: 'Wire', color: 'rgba(76, 167, 229)', type: 'factory_production' };
const switch_ = { _id: 'switch', name: 'Switch', color: 'rgba(76, 167, 229)', type: 'factory_production' };
const transistor = { _id: 'transistor', name: 'Transistor', color: 'rgba(76, 167, 229)', type: 'factory_production' };
const microchip = { _id: 'microchip', name: 'Microchip', color: 'rgba(76, 167, 229)', type: 'factory_production' };
const circuit = { _id: 'circuit', name: 'Circuit', color: 'rgba(76, 167, 229)', type: 'factory_production' };
const device = { _id: 'device', name: 'Device', color: 'rgba(76, 167, 229)', type: 'factory_production' };

const condensate = { _id: 'condensate', name: 'Condensate', color: 'rgba(218, 107, 245)', type: 'factory_production' };
const concentrate = { _id: 'concentrate', name: 'Concentrate', color: 'rgba(218, 107, 245)', type: 'factory_production' };
const extract = { _id: 'extract', name: 'Extract', color: 'rgba(218, 107, 245)', type: 'factory_production' };
const spirit = { _id: 'spirit', name: 'Spirit', color: 'rgba(218, 107, 245)', type: 'factory_production' };
const emanation = { _id: 'emanation', name: 'Emanation', color: 'rgba(218, 107, 245)', type: 'factory_production' };
const essence = { _id: 'essence', name: 'Essence', color: 'rgba(218, 107, 245)', type: 'factory_production' };

const O = { _id: 'O', name: 'Oxygen', color: 'rgba(151, 151, 151, .1)', type: 'resource' };
const H = { _id: 'H', name: 'Hydrogen', color: 'rgba(151, 151, 151, .1)', type: 'resource' };
const Z = { _id: 'Z', name: 'Zynthium', color: 'rgba(247, 212, 146, .1)', type: 'resource' };
const K = { _id: 'K', name: 'Keanium', color: 'rgba(153, 118, 247, .1)', type: 'resource' };
const U = { _id: 'U', name: 'Utrium', color: 'rgba(117, 213, 245, .1)', type: 'resource' };
const L = { _id: 'L', name: 'Lemergium', color: 'rgba(108, 240, 169, .1)', type: 'resource' };
const X = { _id: 'X', name: 'Catalyst', color: 'rgba(243, 129, 127, .1)', type: 'resource' };

const OH = { _id: 'OH', name: 'Hydroxide', color: '', type: 'compound' };
const ZK = { _id: 'ZK', name: 'Zynthium Keanite', color: '', type: 'compound' };
const UL = { _id: 'UL', name: 'Utrium Lemergite', color: '', type: 'compound' };
const G = { _id: 'G', name: 'Ghodium', color: '#FFFFFF', type: 'compound' };

const KH = { _id: 'KH', name: 'Keanium Hydride', color: '#9976F7', type: 'tier' };
const KH2O = { _id: 'KH2O', name: 'Keanium Acid', color: '#9976F7', type: 'tier' };
const XKH2O = { _id: 'XKH2O', name: 'Catalyzed Keanium Acid', color: '#9976F7', type: 'tier' };
const KO = { _id: 'KO', name: 'Keanium Oxide', color: '#9976F7', type: 'tier' };
const KHO2 = { _id: 'KHO2', name: 'Keanium Alkalide', color: '#9976F7', type: 'tier' };
const XKHO2 = { _id: 'XKHO2', name: 'Catalyzed Keanium Alkalide', color: '#9976F7', type: 'tier' };

const UH = { _id: 'UH', name: 'Utrium Hydride', color: '#75D5F5', type: 'tier' };
const UH2O = { _id: 'UH2O', name: 'Utrium Acid', color: '#75D5F5', type: 'tier' };
const XUH2O = { _id: 'XUH2O', name: 'Catalyzed Utrium Acid', color: '#75D5F5', type: 'tier' };
const UO = { _id: 'UO', name: 'Utrium Oxide', color: '#75D5F5', type: 'tier' };
const UHO2 = { _id: 'UHO2', name: 'Utrium Alkalide', color: '#75D5F5', type: 'tier' };
const XUHO2 = { _id: 'XUHO2', name: 'Catalyzed Utrium Alkalide', color: '#75D5F5', type: 'tier' };

const LH = { _id: 'LH', name: 'Lemergium Hydride', color: '#6CF0A9', type: 'tier' };
const LH2O = { _id: 'LH2O', name: 'Lemergium Acid', color: '#6CF0A9', type: 'tier' };
const XLH2O = { _id: 'XLH2O', name: 'Catalyzed Lemergium Acid', color: '#6CF0A9', type: 'tier' };
const LO = { _id: 'LO', name: 'Lemergium Oxide', color: '#6CF0A9', type: 'tier' };
const LHO2 = { _id: 'LHO2', name: 'Lemergium Alkalide', color: '#6CF0A9', type: 'tier' };
const XLHO2 = { _id: 'XLHO2', name: 'Catalyzed Lemergium Alkalide', color: '#6CF0A9', type: 'tier' };

const ZH = { _id: 'ZH', name: 'Zynthium Hydride', color: '#F7D492', type: 'tier' };
const ZH2O = { _id: 'ZH2O', name: 'Zynthium Acid', color: '#F7D492', type: 'tier' };
const XZH2O = { _id: 'XZH2O', name: 'Catalyzed Zynthium Acid', color: '#F7D492', type: 'tier' };
const ZO = { _id: 'ZO', name: 'Zynthium Oxide', color: '#F7D492', type: 'tier' };
const ZHO2 = { _id: 'ZHO2', name: 'Zynthium Alkalide', color: '#F7D492', type: 'tier' };
const XZHO2 = { _id: 'XZHO2', name: 'Catalyzed Zynthium Alkalide', color: '#F7D492', type: 'tier' };

const GH = { _id: 'GH', name: 'Ghodium Hydride', color: '#FFFFFF', type: 'tier' };
const GH2O = { _id: 'GH2O', name: 'Ghodium Acid', color: '#FFFFFF', type: 'tier' };
const XGH2O = { _id: 'XGH2O', name: 'Catalyzed Ghodium Acid', color: '#FFFFFF', type: 'tier' };
const GO = { _id: 'GO', name: 'Ghodium Oxide', color: '#FFFFFF', type: 'tier' };
const GHO2 = { _id: 'GHO2', name: 'Ghodium Alkalide', color: '#FFFFFF', type: 'tier' };
const XGHO2 = { _id: 'XGHO2', name: 'Catalyzed Ghodium Alkalide', color: '#FFFFFF', type: 'tier' };

export default {
    token, cpuUnlock, pixel, accessKey,
    energy, power, ops,
    metal, biomass, silicon, mist,

    oxidant, reductant, zynthium_bar,
    lemergium_bar, utrium_bar, keanium_bar, purifier,

    battery, ghodium_melt, composite, crystal, liquid,

    wire, switch: switch_, switch_, transistor, microchip, circuit, device,
    cell, phlegm, tissue, muscle, organoid, organism,
    alloy, tube, fixtures, frame, hydraulics, machine,
    condensate, concentrate, extract, spirit, emanation, essence,

    O, H, Z, K, U, L, X,
    OH, ZK, UL, G,
    KH, KH2O, XKH2O, KO, KHO2, XKHO2,
    UH, UH2O, XUH2O, UO, UHO2, XUHO2,
    LH, LH2O, XLH2O, LO, LHO2, XLHO2,
    ZH, ZH2O, XZH2O, ZO, ZHO2, XZHO2,
    GH, GH2O, XGH2O, GO, GHO2, XGHO2
};
